module.exports = __webpack_public_path__ + "static/media/cooler.070cb3b7.svg";